import ProposalQuestion from './ProposalQuestion';
export default ProposalQuestion;